<template>
    <nav aria-label="Progress" class="">
        <ol role="list" class="flex items-center">
            <li
                v-for="(step, stepIdx) in steps"
                :key="step.name"
                :class="[
                    stepIdx !== steps.length - 1 ? 'pr-24 sm:pr-40' : '',
                    'relative',
                ]"
            >
                <template v-if="step.status === 'complete'">
                    <div
                        class="absolute inset-0 flex items-center"
                        aria-hidden="true"
                    >
                        <div class="h-0.5 w-full bg-primaryBlue-80" />
                    </div>
                    <div
                        class="relative w-8 h-8 flex items-center justify-center bg-primaryBlue-80 rounded-full hover:bg-primaryBlue-100"
                    >
                        <i class="fas fa-check w-5 h-5 text-white"></i>

                        <span class="sr-only">{{ step.name }}</span>
                    </div>
                </template>
                <template
                    v-else-if="step.status === 'current'"
                    condition="step.status === 'current'"
                >
                    <div
                        class="absolute inset-0 flex items-center"
                        aria-hidden="true"
                    >
                        <div class="h-0.5 w-full bg-gray-200" />
                    </div>
                    <div
                        class="relative w-8 h-8 flex items-center justify-center bg-white border-2 border-primaryBlue-80 rounded-full"
                        aria-current="step"
                    >
                        <span
                            class="h-2.5 w-2.5 bg-primaryBlue-80 rounded-full"
                            aria-hidden="true"
                        />
                        <span class="sr-only">{{ step.name }}</span>
                    </div>
                </template>
                <template v-else>
                    <div
                        class="absolute inset-0 flex items-center"
                        aria-hidden="true"
                    >
                        <div class="h-0.5 w-full bg-gray-200" />
                    </div>
                    <div
                        class="group relative w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full hover:border-gray-400"
                    >
                        <span
                            class="h-2.5 w-2.5 bg-transparent rounded-full group-hover:bg-gray-300"
                            aria-hidden="true"
                        />
                        <span class="sr-only">{{ step.name }}</span>
                    </div>
                </template>
            </li>
        </ol>
    </nav>
</template>

<script>
export default {
    data: function () {
        return {
            stepOptions: [
                [
                    {
                        id: 1,
                        name: "Register",
                        status: "current",
                    },
                    {
                        id: 2,
                        name: "Contact Details",
                        status: "upcoming",
                    },
                    {
                        id: 3,
                        name: "Address Details",
                        status: "upcoming",
                    },
                ],
                [
                    {
                        id: 1,
                        name: "Register",
                        status: "complete",
                    },
                    {
                        id: 2,
                        name: "Contact Details",
                        status: "current",
                    },
                    {
                        id: 3,
                        name: "Address Details",
                        status: "upcoming",
                    },
                ],
                [
                    {
                        id: 1,
                        name: "Register",
                        status: "complete",
                    },
                    {
                        id: 2,
                        name: "Contact Details",
                        status: "complete",
                    },
                    {
                        id: 3,
                        name: "Address Details",
                        status: "current",
                    },
                ],
            ],
        };
    },
    props: {
        step: {
            type: Number,
            required: true,
        },
    },
    mounted() {},
    methods: {},
    computed: {
        steps() {
            return this.stepOptions[this.step - 1];
        },
    },
};
</script>
